import { render, staticRenderFns } from "./Dorms.vue?vue&type=template&id=3fc71a87&scoped=true&"
import script from "./Dorms.vue?vue&type=script&lang=js&"
export * from "./Dorms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc71a87",
  null
  
)

export default component.exports